export const concepts_payroll = [
  {
    code:"01",
    description:"01 - HED", 
    type:1,
    unit_time:'HORA',
    percentage: 25,
  }
  ,{
    code:"02",
    description:"02 - HEN", 
    type:1,
    unit_time:'HORA',
    percentage: 75,
  }
  ,{
    code:"03",
    description:"03 - HRN", 
    type:1,
    unit_time:'HORA',
    percentage: 35,
  }
  ,{
    code:"04",
    description:"04 - HEDDF", 
    type:1,
    unit_time:'HORA',
    percentage: 100,
  }
  ,{
    code:"05",
    description:"05 - HRDDF", 
    type:1,
    unit_time:'HORA',
    percentage: 75,
  }
  ,{
    code:"06",
    description:"06 - HENDF", 
    type:1,
    unit_time:'HORA',
    percentage: 150,
  }
  ,{
    code:"07",
    description:"07 - HRNDF", 
    type:1,
    unit_time:'HORA',
    percentage: 110,
  }
  ,{
    code:"08",
    description:"08 - VACACIONES", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"09",
    description:"09 - LICENCIA PATERNIDAD/MATERNIDAD", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"10",
    description:"10 - LINCENCIA REMUNERADA", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"11",
    description:"11 - LINCENCIA NO REMUNERADA", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"12",
    description:"12 - OTRO DEVENGADO", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"13",
    description:"13 - PRIMA", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"14-1",
    description:"141 - INCAPACIDAD COMUN", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"14-2",
    description:"142 - INCAPACIDAD PROFESIONAL", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"14-3",
    description:"143 - INCAPACIDAD LABORAL", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"18", //falta
    description:"18 - SUELDO", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"19",
    description:"19 - CESANTIAS", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"22", //falta
    description:"22 - AUXILIO TRANSPORTE", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"23",
    description:"23 - INTERESES CESANTIAS", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"24",
    description:"24 - BONIFICACIONES SALARIALES", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"25",
    description:"25 - BONIFICACIONES NO SALARIALES", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"26",
    description:"26 - AUXILIOS SALARIALES", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"27",
    description:"27 - AUXILIOS NO SALARIALES", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"28",
    description:"28 - HUELGAS LEGALES", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"29",
    description:"29 - COMPENSACIONES", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"30",
    description:"30 - COMISIONES", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"31",
    description:"31 - PAGOS_TERCEROS", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"32",
    description:"32 - ANTICIPOS", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"33",
    description:"33 - DOTACION", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"34",
    description:"34 - APOYO", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"35",
    description:"35 - TELETRABAJO", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"36",
    description:"36 - BONIFICACION_RETIRO", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"37",
    description:"37 - INDEMNIZACION", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"38",
    description:"38 - REINTEGRO", 
    type:1,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"15",
    description:"15 - LIBRANZA", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"16",
    description:"16 - ANTICIPO", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"17",
    description:"17 - OTRAS DEDUCC", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"20", //falta
    description:"20 - EPS", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"21", //falta
    description:"21 - PENSION", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"39",
    description:"39 - SINDICATOS", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"40",
    description:"40 - SANCIONES PUBLICA", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"41",
    description:"41 - SANCIONES", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"42",
    description:"42 - PAGOS_TERCEROS", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"43",
    description:"43 - PENSION_VOLUNTARIA", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"44",
    description:"44 - RETENCION_FUENTE", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"45",
    description:"45 - AFC", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"46",
    description:"46 - COOPERATIVA", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"47",
    description:"47 - EMBARGO_FISCAL", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"48",
    description:"48 - PLAN_COMPLEMENTARIOS", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"49",
    description:"49 - EDUCACION", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"50",
    description:"50 - REINTEGRO", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
  ,{
    code:"51",
    description:"51 - DEUDA", 
    type:2,
    unit_time:'HORA',
    percentage: 0,
  }
]


// WEBPACK FOOTER //
// ./src/components/nomina/localdata/conceptos.js